import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./utils/useRouterScroll";
import TagManager from "react-gtm-module";

import Index from "./pages/paet/index";
import ClaveSeguridad from "./pages/paet/ClaveSeguridad";
import Paet from "./pages/paet/Paet";
import Consulta from "./pages/paet/Consulta";
import DatosMandatario from "./pages/paet/Mandatario";
import DatosAfiliado from "./pages/paet/Afiliado";
import DatosBeneficiario from "./pages/paet/Beneficiario";
import DatosCuentas from "./pages/paet/Cuentas";
import DatosPago from "./pages/paet/Pago";
import Documentos from "./pages/paet/Documento";
import Comprobante from "./pages/paet/Comprobante";
import Resumen from "./pages/paet/Resumen";

import IndexELD from "./pages/eld/index";
import ModalidadPagoELD from "./pages/eld/modalidadPago";
import ComprobanteELD from "./pages/eld/comprobante";
import ResumenLD from "./pages/eld/resumen";

import Login from "./pages/doc/login";
import FormaPagodos from "./pages/doc/newDocumentos"
import ComprobanteV2 from "./pages/doc/comprobantev2";

import Pin from "./pages/pin/Index";
import Send from "./pages/pin/Send";
import Code from "./pages/pin/Code";
import Authenticate from "./pages/pin/Authenticate";
import Enrolled from "./pages/pin/Enrolled";
import Update from "./pages/pin/Update";

import PageNotFound from "./pages/PageNotFound"

import "./assets/css/globals.css";
import "./assets/css/index.css";
import "./assets/css/custom.css"

const tagManagerArgs = {
    gtmId: 'GTM-TBL58B3'
}

TagManager.initialize(tagManagerArgs)

const App = function () {

    return (
        <>
            <Header />
            <BrowserRouter>
                <ScrollToTop />
                <Routes>

                    {/*PAET*/}
                    <Route path="/" element={<Paet />} />
                    <Route path="/paet" element={<Paet />} />
                    <Route path="/paet/index" element={<Index />} />
                    <Route path="/paet/claveSeguridad" element={<ClaveSeguridad />} />
                    <Route path="/paet/consultar" element={<Consulta />} />
                    <Route path="/paet/mandatario" element={<DatosMandatario />} />
                    <Route path="/paet/datosAfiliados" element={<DatosAfiliado />} />
                    <Route path="/paet/beneficiarios" element={<DatosBeneficiario />} />
                    <Route path="/paet/cuentas" element={<DatosCuentas />} />
                    <Route path="/paet/formaPago" element={<DatosPago />} />
                    <Route path="/paet/documentos" element={<Documentos />} />
                    <Route path="/paet/comprobante" element={<Comprobante />} />
                    <Route path="/paet/resumen" element={<Resumen />} />

                    {/*PIN PAET*/}
                    <Route path="/pin" element={<Pin />} />
                    <Route path="/pin/send/:id" element={<Send />} />
                    <Route path="/pin/code/:id/:method/:step" element={<Code />} />
                    <Route path="/pin/login" element={<Authenticate />} />
                    <Route path="/pin/qr-enroll" element={<Enrolled />} />
                    <Route path="/pin/qr-enroll/:state" element={<Enrolled />} />
                    <Route path="/pin/update-info/:id" element={<Update />} />

                    {/*ELD PAET*/}
                    <Route path="/eld" element={<IndexELD />} />
                    <Route path="/eld/modalidadPago" element={<ModalidadPagoELD />} />
                    <Route path="/eld/comprobante" element={<ComprobanteELD />} />
                    <Route path="/eld/resumen" element={<ResumenLD />} />

                    {/*DOC PAET*/}
                    <Route path="/doc/login" element={<Login />} />
                    <Route path="/doc/documentos" element={<FormaPagodos />} />
                    <Route path="/doc/resumen" element={<ComprobanteV2 />} />

                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </BrowserRouter>
            <Footer />
        </>
    );
}

export default App;